export default __webpack_public_path__ + "static/7_color-dodge-cbb8e3db6bfccf0d811f8bf4049dbe3b.png";